var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',[_vm._v(" Test ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }